import GridVoucherFormPage from "./GridVoucherFormPage";

/**
 * Debit Note - increases a member's or vendor's outstanding balance without
 * a bank/cash movement (e.g. an additional charge or a correction). Same
 * multi-line grid as Credit Note / Journal; accounting mapping depends on
 * context so ledgers are chosen per line rather than fixed.
 */
export default function DebitNotePage() {
  return (
    <GridVoucherFormPage
      voucherType="DEBIT_NOTE"
      title="Debit Note"
      subtitle="Increase a member's or vendor's outstanding balance without a bank/cash movement. Reference the original bill and state the reason in the narration."
      referenceLabel="Original Reference"
      showVendorHelper
      emptyStateNote="No debit notes yet. Create your first debit note above."
    />
  );
}
